import { Injectable } from '@angular/core';
import { KeycloakService as KeycloakAngular, KeycloakOptions } from 'keycloak-angular';

const DEFAULT_SESSION_RENEWAL_TIME = 50; // in seconds;

@Injectable({
    providedIn: 'root'
})
export class KeycloakService {
    public keycloakAngular: KeycloakAngular;
    public sessionRenewalTime: number = DEFAULT_SESSION_RENEWAL_TIME;

    constructor() {
        this.keycloakAngular = new KeycloakAngular();
    }

    init = (environmentKeycloak: KeycloakOptions, sessionRenewalTime: number) => {
        this.sessionRenewalTime = sessionRenewalTime;

        return this.keycloakAngular.init(
            {
                ...(environmentKeycloak)
            }
        );
    };

    logout = () =>  {
        this.keycloakAngular.getKeycloakInstance()?.logout();
    };

    getParsedToken = () => {
        return this.keycloakAngular && this.keycloakAngular.getKeycloakInstance()
            ? this.keycloakAngular.getKeycloakInstance().tokenParsed
            : null;
    };

    getToken = () => {
        return this.keycloakAngular && this.keycloakAngular.getKeycloakInstance()
            ? this.keycloakAngular.getKeycloakInstance().token
            : '';
    };

    login = () => {
        this.keycloakAngular.login();
    };

    getTokenExpirationTime = () =>  {
        return this.keycloakAngular.getKeycloakInstance().tokenParsed?.exp;
    };

    getIsTokenExpired = () => {
        return this.keycloakAngular.getKeycloakInstance().isTokenExpired();
    };

    tryTokenUpdate = (onSuccess: () => void) => {
        this.keycloakAngular
            .updateToken()
            .then(() => {
                return onSuccess && onSuccess();
            })
            .catch(() => {
                this.keycloakAngular.logout();
            });
    };
}